<div *ngFor="let check of info" class="check-item">
  <div><span *ngIf="check.IsMandatory">*</span></div> <mat-checkbox class="response" [checked]="check.Checked" [disabled]="true"></mat-checkbox>
  <p *ngIf="!check.IsMandatory">{{check.Value}}</p>
  <p *ngIf="check.IsMandatory"><b>{{check.Value}}</b></p>
</div>
<p *ngIf="mandatory">*{{'report_mandatory' | translate}}</p>
